// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*DESKTOP*/
@media screen and (min-width:1024px) {
   .ListUser_container__ppqgA{
       display: flex;
       place-content: center;
       text-transform: capitalize;
   }

   .ListUser_container__ppqgA > div {
       width: 95%;
   }

   .ListUser_options__gI412 {
       display: flex;
       padding-top: 1%;
       place-content: center;
   }
}

/*TABLET*/
@media screen and (min-width:767px) and (max-width:1024px) {
   .ListUser_container__ppqgA{
       display: flex;
       place-content: center;
       text-transform: capitalize;
   }

   .ListUser_container__ppqgA > div {
       width: 90%;
   }

   .ListUser_options__gI412 {
       display: flex;
       padding-top: 1%;
       place-content: center;
   }
}

/*MOBILE*/
@media screen and (max-width:767px) {
   .ListUser_container__ppqgA{
       display: flex;
       place-content: center;
       text-transform: capitalize;
   }

   .ListUser_container__ppqgA > div {
       width: 90%;
   }

   .ListUser_options__gI412 {
       display: flex;
       padding-top: 1%;
       place-content: center;
   }
}`, "",{"version":3,"sources":["webpack://./src/pages/user_list/ListUser.module.css"],"names":[],"mappings":"AAAA,UAAU;AACV;GACG;OACI,aAAa;OACb,qBAAqB;OACrB,0BAA0B;GAC9B;;GAEA;OACI,UAAU;GACd;;GAEA;OACI,aAAa;OACb,eAAe;OACf,qBAAqB;GACzB;AACH;;AAEA,SAAS;AACT;GACG;OACI,aAAa;OACb,qBAAqB;OACrB,0BAA0B;GAC9B;;GAEA;OACI,UAAU;GACd;;GAEA;OACI,aAAa;OACb,eAAe;OACf,qBAAqB;GACzB;AACH;;AAEA,SAAS;AACT;GACG;OACI,aAAa;OACb,qBAAqB;OACrB,0BAA0B;GAC9B;;GAEA;OACI,UAAU;GACd;;GAEA;OACI,aAAa;OACb,eAAe;OACf,qBAAqB;GACzB;AACH","sourcesContent":["/*DESKTOP*/\n@media screen and (min-width:1024px) {\n   .container{\n       display: flex;\n       place-content: center;\n       text-transform: capitalize;\n   }\n\n   .container > div {\n       width: 95%;\n   }\n\n   .options {\n       display: flex;\n       padding-top: 1%;\n       place-content: center;\n   }\n}\n\n/*TABLET*/\n@media screen and (min-width:767px) and (max-width:1024px) {\n   .container{\n       display: flex;\n       place-content: center;\n       text-transform: capitalize;\n   }\n\n   .container > div {\n       width: 90%;\n   }\n\n   .options {\n       display: flex;\n       padding-top: 1%;\n       place-content: center;\n   }\n}\n\n/*MOBILE*/\n@media screen and (max-width:767px) {\n   .container{\n       display: flex;\n       place-content: center;\n       text-transform: capitalize;\n   }\n\n   .container > div {\n       width: 90%;\n   }\n\n   .options {\n       display: flex;\n       padding-top: 1%;\n       place-content: center;\n   }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ListUser_container__ppqgA`,
	"options": `ListUser_options__gI412`
};
export default ___CSS_LOADER_EXPORT___;
